import { getAPI } from "./base";

// Category Specific News
export async function fetchCategorySpecificNews(formValues) {
  try {
    const api = getAPI();
    const params = {
      Country: formValues.country,
      Category: formValues.category,
      accountId: formValues.accountId || null,
    };
    const response = await api.get("/categorynews", { params });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error(
        "Error fetching category specific news data: ",
        response.statusText,
      );
    }
  } catch (error) {
    console.error("Error fetching category specific news data: ", error);
  }
}

// General News
export async function fetchGeneralNews(formValues) {
  try {
    const api = getAPI();
    const params = {
      Country: formValues.country,
      offset: formValues.offset || 0,
      limit: formValues.limit || 20,
      bookmarks_only: formValues.bookmarks_only || false,
    };

    const response = await api.get("/news", { params });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching general news data: ", response.statusText);
      return null;
    }
  } catch (error) {
    console.error("Error fetching general news data: ", error);
    return null;
  }
}

// News Bookmarks
// Fetch Saved Bookmarks
export async function fetchUserBookmarks() {
  try {
    const api = getAPI();
    const response = await api.get("/user_bookmarks");

    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching user bookmarks: ", response.statusText);
      return null;
    }
  } catch (error) {
    console.error("Error fetching user bookmarks: ", error);
    return null;
  }
}

// SAVE General News as bookmarks
export async function saveBookmarks(news_id) {
  try {
    const api = getAPI();
    const response = await api.post(`/save_bookmark?news_id=${news_id}`);
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error saving bookmark: ", response.statusText);
      return null;
    }
  } catch (error) {
    console.error("Error saving bookmark: ", error);
    return null;
  }
}

// DELETE General News as bookmarks
export async function deleteBookmarks(news_id) {
  try {
    const api = getAPI();
    const response = await api.delete(`/delete_bookmark?news_id=${news_id}`);
    if (response.status === 200) {
      return true;
    } else {
      console.error("Error delete bookmark: ", response.statusText);
      return false;
    }
  } catch (error) {
    console.error("Error delete bookmark: ", error);
    return false;
  }
}
